/* eslint-disable prefer-arrow/prefer-arrow-functions */

import React from 'react';
import { SelectedRepetitionChangeStream } from '../../../../data/change_streams/selected_repetition/selected_repetition_change_stream';
import { ITestRepetition } from '../../../../data/types';
import {
  RepetitionsEditState,
  UseEditRepetitionsReturn,
} from '../../../../hooks/repetitions/useEditRepetitions';
import { Row } from '../../../layout/Row';
import { Button, SaveButton } from '../../Button';
import { RepetitionSelect } from '../../form/selects/RepetitionSelect';
interface IProps {
  repetitions: ITestRepetition[];
  selectedRepetition: ITestRepetition | null;
  selectedRepetitionChangeStream: SelectedRepetitionChangeStream;
  editRepetitions: UseEditRepetitionsReturn;
}

export function EditRepetitions(props: IProps): React.ReactElement {
  /// if there are no repetitions, render nothing
  if (!props.repetitions || props.repetitions.length === 0) {
    return null;
  }

  const renderButton = (): React.ReactElement => {
    if (props.editRepetitions.editState === RepetitionsEditState.Editing) {
      return (
        <SaveButton onClick={props.editRepetitions.saveChanges} />
      );
    }

    if (props.editRepetitions.editState === RepetitionsEditState.Saving) {
      return (
        <SaveButton onClick={() => null} disabled={true} />
      );
    }

    return (
      <Button
        icon='edit'
        title='Edit'
        onClick={props.editRepetitions.startEditing}
        style={{ whiteSpace: 'nowrap' }}
      />
    );
  };

  return (
    <Row>
      <RepetitionSelect
        repetitions={props.repetitions}
        selectedRepetition={props.selectedRepetition}
        selectedRepetitionChangeStream={props.selectedRepetitionChangeStream}
      />
      {renderButton()}
    </Row>
  );
}
